import type { PropsWithChildren } from "react";
import { Suspense } from "react";

import { TemplateCategory } from "@/components/confluence/templates/template-categories-search";
import { TemplateProvider } from "@/content/templates/template.provider";
import {
    Template,
    type TemplateCollection
} from "@/content/templates/template.types";
import ContentNotFoundErrorBoundary from "@/content/utils/content-not-found-error-boundary";
import { CategoryOrder } from "@/templates/software/confluence/templates/confluence-templates-page/src/config/category-template-order.ts";
import { DetailPageContent } from "@/templates/software/confluence/templates/confluence-templates-page/src/template-details-page/confluence-template-details-page.template.tsx";
import { experiments, useExperiment } from "@/utils/experiment";
import { withFeatureExposed } from "@/utils/feature-exposed";

import { DetailPageContentCfind3646 } from "./cfind3646-sections/cfind3646-exp-confluence-template-details-page.template";
import { SharedHeaderFooterContainer } from "./sections/shared-header-footer-container";

export type ConfluenceTemplateDetailsPageTemplateProps = PropsWithChildren<{
    templates: Template[];
    collections: TemplateCollection[];
    categories: TemplateCategory[];
}>;
export const ConfluenceTemplateDetailsPageTemplateComponent = ({
    templates,
    collections,
    categories
}: ConfluenceTemplateDetailsPageTemplateProps) => {
    const CFIND3646EmbeddedSignup = useExperiment(
        experiments.cfind3646TemplateDetailseEmbeddedSignup
    );

    const isEnrolled =
        CFIND3646EmbeddedSignup.type === "enrolled" &&
        CFIND3646EmbeddedSignup.value;

    const renderComponent = () => {
        if (isEnrolled) {
            return <DetailPageContentCfind3646 />;
        } else return <DetailPageContent />;
    };

    return (
        <SharedHeaderFooterContainer>
            <ContentNotFoundErrorBoundary>
                <TemplateProvider
                    templates={templates}
                    collections={collections}
                    categories={categories}
                    categoriesSortBy={CategoryOrder}
                >
                    <Suspense>{renderComponent()}</Suspense>
                </TemplateProvider>
            </ContentNotFoundErrorBoundary>
        </SharedHeaderFooterContainer>
    );
};

export const ConfluenceTemplateDetailsPageTemplate = withFeatureExposed(
    "template-details-page-template-details-seo-v2",
    "enrolled",
    ConfluenceTemplateDetailsPageTemplateComponent
);
